import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import DownloadApp from './pages/DownloadApp';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DownloadApp />} />
        <Route path="/telecharger" element={<DownloadApp />} />
        <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
        <Route path="/conditions-generales" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
}

export default App;
